import styled, { css } from "styled-components/macro";
import { COLORES } from "../../constants";

export const Nav = styled.nav`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: ${COLORES.MENU_BACKGROUND};
  border-bottom: thin solid ${COLORES.LIGHT_BORDER};
  font-size: 0.75rem;
  font-weight: bold;
  z-index: 5;
`;

export const Img = styled.img`
  height: 1.5rem;
  margin: 0 0.75rem;
`;

export const MenuContainer = styled.div`
  ul {
    display: flex;
    height: 2.5rem;
    align-items: center;
  }

  li {
    list-style: none;
    line-height: 1rem;
    padding: 0.75rem 0rem;

    :hover {
      background-color: ${COLORES.MENU_HOVER};
    }

    &.active {
      background-color: ${COLORES.MENU_ACTIVE};
      a {
        color: white;
      }
    }
  }

  a,
  div {
    display: inline;
    color: ${COLORES.BLACK};
    text-decoration: none;
    padding: 0.75rem 1.5rem;
    cursor: pointer;
  }
`;

export const UserContainer = styled.div`
  display: flex;
  margin-left: auto;

  button {
    color: black;
    background-color: white;
    height: 1.75rem;
    width: 1.75rem;
    font-size: 0.875rem;
    font-weight: bold;
    margin: 0 1rem;
    padding: 0.35rem 0.5rem;
    border: none;
    border: thin solid ${COLORES.GRIS_CLARO};
    :hover {
      background-color: ${COLORES.GRIS_CLARO};
    }
  }

  p {
    display: inline;
    color: ${COLORES.BLACK};
    text-decoration: none;
    line-height: 1rem;
    padding: 0.75rem 0rem;
  }
`;

export const User = styled.p`
  font-weight: 600;
`;

export const ButtonsContainer = styled.div`
  align-self: center;
`;

export const Ul = styled.ul`
  list-style: none;
  background-color: ${COLORES.BACKGROUND};
  border: thin solid ${COLORES.LIGHT_BORDER};
  border-radius: 0.2rem;
  font-size: 0.9rem;
  position: absolute;
  right: 1rem;
  text-align: right;

  a {
    text-decoration: none;
    color: ${COLORES.BLACK};
  }

  #last {
    border-bottom: none;
    span {
      color: ${COLORES.MENU_ACTIVE};
      margin-right: 0.25rem;
    }
  }
`;

export const Li = styled.li`
  font-size: 0.75rem;
  font-weight: normal;
  margin: auto;
  height: 1.75rem;
  line-height: 1.75rem;
  padding: 0 0.5rem;
  border-bottom: thin solid ${COLORES.LIGHT_BORDER};
  cursor: pointer;
  :hover {
    background-color: ${COLORES.HIGHLIGHTED};
  }
  ${(props) =>
    props.disabled &&
    css`
      color: ${COLORES.TEXT_DISABLED};
      cursor: auto;
    `}
`;
